import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home'
import Team from './views/Team'
import Phone from './views/Phone'
import Invitelist from './views/Invitelist'
import ShareIndex from './views/ShareIndex'
import Login from './views/Login'
import WXLoginResult from './views/WXLoginResult'
import config from '@/config';

Vue.use(Router)

var router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // },
    {
      meta: { title: "无忧行伴我行", auth: 0 },
      path: "/login",
      name: "login",
      component: Login
    },
    {
      meta: { title: "无忧行伴我行", auth: 1 },
      path:"/home",
      component:Home
    },
    {
      meta: { title: "无忧行伴我行", auth: 1 },
      path:"/team",
      component:Team
    },
    {
      meta: { title: "无忧行伴我行", auth: 1 },
      path:"/phone",
      component:Phone
    },
    {
      meta: { title: "无忧行伴我行", auth: 1 },
      path:"/invitelist",
      component:Invitelist
    },
    {
      meta: { title: "无忧行伴我行", auth: 0 },
      path:"/",
      component:ShareIndex
    },
    {
      meta: { title: "无忧行伴我行", auth: 0 },
      path:"/wxloginresult",
      component:WXLoginResult
    },
  ]
});
var keyUrl = function(){
  var items = [];
  var url = location.href;
  if (url === undefined || typeof url != "string") {
    return null;
  }
  var json = {};
  var newurl = url.split("#")[0];
  var arr = newurl.split("?");
  if (arr.length > 1) {
    items = arr[1].split("&");
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i].split("=");
      json[item[0]] = item[1];
    }
  }
  return json;
}
//路由守卫
router.beforeEach((to, from, next) => {
  var next_url = {
    path:"",
    query:{}
  }
  if (to.meta) {
    /* 路由发生变化修改页面title */
    if(to.meta.title) document.title = to.meta.title;
    else document.title = "无忧行伴我行";
    /* 验证授权 */
    do{
      if(!to.meta.auth || to.meta.auth==0) break;
      // localStorage.removeItem(config.login_key);
      var app_login_user = localStorage.getItem(config.login_key);
      if(app_login_user) app_login_user = JSON.parse(app_login_user);
      // sessionkey = '24681570c3751d3939157361a69f6ed1b4dad553'
      // localStorage.setItem("sessionkey", sessionkey);
      console.log(to.meta.auth==1 && app_login_user==null)
      console.log(to.meta.auth)
      console.log('888')
      console.log(app_login_user)
      // console.log(to)
      //前台授权
      if(to.meta.auth==1 && app_login_user==null)
      {
        console.log("JSON.stringify(to)",JSON.stringify(to))
        localStorage.setItem("login_redirect",JSON.stringify(to));
        next_url.path = "/login";
        var urlData = keyUrl();
        var q = to.query;
        if (q.a || q.auth_token) {
          urlData = q;
        }
        // if(urlData.sessionkey) break;
        // if(urlData.) next_url.query = {auth_token:urlData.auth_token};
        next_url.query = urlData;
        break;
      }
    }while(false);
  }
  if(next_url.path!="" && next_url.path.indexOf("://")>=0)
    window.location.href=next_url.path;
  else if(next_url.path!="") 
    next(next_url)
  else next();
});

export default router;
